import script from "./DashBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=1590908a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1590908a"]])

export default __exports__